export default [
  {
    name: 'Concierge Reservations',
    path: '#/account/concierge-reservations',
    translationKey: 'concierge_reservations',
    activeMatcher: 'account/concierge-reservations',
    isConcierge: true,
  },
  {
    name: 'Reservations',
    path: '#/account/reservations-and-notify',
    translationKey: 'reservations_and_notify',
    activeMatcher: 'account/reservations-and-notify',
  },
  {
    name: 'Profile',
    path: '#/account/profile',
    translationKey: 'profile',
    activeMatcher: 'account/profile',
  },
  {
    name: 'Payment Methods',
    path: '#/account/payment-methods',
    translationKey: 'payment_methods_title',
    activeMatcher: 'account/payment-methods',
  },
  {
    name: 'Communication',
    path: '#/account/communication',
    translationKey: 'communication_title',
    activeMatcher: 'account/communication',
  },
  {
    name: 'Help & Feedback',
    path: '#/account/help-and-feedback',
    translationKey: 'help_and_feedback_title',
    activeMatcher: 'account/help-and-feedback',
  },
];
